import { api } from '../lib/api';

export const workspaceApi = {
  getAll: async () => {
    const response = await api.get('/workspaces');
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await api.get(`/workspaces/${id}`);
    return response.data;
  },

  create: async (data: { name: string }) => {
    const response = await api.post('/workspaces', data);
    return response.data;
  },

  update: async (id: string, data: { name: string }) => {
    const response = await api.patch(`/workspaces/${id}`, data);
    return response.data;
  },

  // ── Members ────────────────────────────────────────────────────────────────

  getMembers: async (workspaceId: string) => {
    const response = await api.get(`/workspaces/${workspaceId}/members`);
    return response.data;
  },

  addMember: async (workspaceId: string, data: { email: string; role: string }) => {
    const response = await api.post(`/workspaces/${workspaceId}/members`, data);
    return response.data;
  },

  updateMember: async (workspaceId: string, memberId: string, data: { role: string }) => {
    const response = await api.patch(`/workspaces/${workspaceId}/members/${memberId}`, data);
    return response.data;
  },

  removeMember: async (workspaceId: string, memberId: string) => {
    await api.delete(`/workspaces/${workspaceId}/members/${memberId}`);
  },
};
